module.exports = __webpack_public_path__ + "img/16.70bd32d8.png";